import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import moment from 'moment';
import OperatorTypes from '../../../common/redux/actions/types/OperatorTypes';
import PostalOperatorSelector from '../../../wizard/target-node-impc-selector/components/PostalOperatorSelector';
import {
  getArrivalPostalOperators,
  getArrivalCheckedMailProcessingCenters,
  getSelectedArrivalPostalOperators,
  getDepartureCheckedOperator,
  getSelectedDepartureOperators,
  getDepartureOperators,
} from '../../../wizard/target-node-impc-selector/redux/selectors/PostalOperatorSelectors';
import {
  retrieveOutboundPostalOperatorsRequestActionCreator,
  departureOperatorCheckedActionCreator,
  onSelectAllDepartureOperators,
  onDeSelectAllDepartureOperators,
} from '../../../wizard/target-node-impc-selector/redux/actions/DeparturePostalOperatorActions';
import {
  retrieveInboundPostalOperatorsRequestActionCreator,
  arrivalMailProcessingCenterCheckedActionCreator,
  onSelectAllArrivalMailProcessingCenters,
  onDeSelectAllArrivalMailProcessingCenters,
} from '../../../wizard/target-node-impc-selector/redux/actions/ArrivalPostalOperatorActions';
import { saveGlobalSelectionOperatorRequestActionCreator, setTabButtonStatus } from '../redux/actions/AdminDashboardActions';
import { createPresetSelectionsOnSave } from '../../../react-table/helpers/utils';
import AdminPresetOperatorSidebarContainer from './AdminPresetOperatorSidebarContainer';

export class GlobalPresetsOperatorContainer extends Component {
  // eslint-disable-next-line no-useless-constructor
  constructor(props) {
    super(props);
    this.state = {
      showOnlySelectedDeparturePostalOperators: false,
      showOnlySelectedArrivalPostalOperators: false,
    };
  }

  componentDidMount() {
    const defaultDate = moment();
    this.props.retrieveOutboundPostalOperatorsRequestActionCreator(
      {
        defaultDirection: 'I',
        startDate: defaultDate,
        endDate: defaultDate,
      },
      '',
      '',
    );

    this.props.retrieveInboundPostalOperatorsRequestActionCreator(
      {
        defaultDirection: 'I',
        startDate: defaultDate,
        endDate: defaultDate,
      },
      '',
      '',
    );
  }

  componentDidUpdate(prevProps) {
    if (this.props.departureCheckedMailProcessingCenters !== prevProps.departureCheckedMailProcessingCenters && this.props.departureCheckedMailProcessingCenters.length !== 0) {
      this.props.setTabButtonStatus(true);
    }
    if (this.props.departureCheckedMailProcessingCenters.length === 0 && prevProps.departureCheckedMailProcessingCenters.length !== 0) {
      this.setState({
        showOnlySelectedDeparturePostalOperators: false,
      });
    }
  }

  onSelectAllDeparturePostalOperators = () => {
    this.props.onSelectAllDepartureOperators(this.props.departurePostalOperatorsNodes);
  };

  onSelectAllArrivalPostalOperators = () => {
    this.props.onSelectAllArrivalMailProcessingCenters(this.props.arrivalPostalOperatorsNodes);
  };

  onDeSelectAllDeparturePostalOperators = () => {
    this.setState({
      showOnlySelectedDeparturePostalOperators: false,
    });
    this.props.onDeSelectAllDepartureOperators();
  };

  onDeSelectAllArrivalPostalOperators = () => {
    this.setState({
      showOnlySelectedArrivalPostalOperators: false,
    });
    this.props.onDeSelectAllArrivalMailProcessingCenters();
  };

  onSelectDeparturePostalOperator = (selected) => {
    if (selected.length === 0) {
      this.setState({
        showOnlySelectedDeparturePostalOperators: false,
      });
    }
    // eslint-disable-next-line react/prop-types
    this.props.departureOperatorCheckedActionCreator(selected, this.props.report);
  };

  onToggleShowOnlySelectedDeparturePostalOperators = () => {
    this.setState({
      // eslint-disable-next-line react/no-access-state-in-setstate
      showOnlySelectedDeparturePostalOperators: !this.state.showOnlySelectedDeparturePostalOperators,
    });
  };

  onToggleShowOnlySelectedArrivalPostalOperators = () => {
    this.setState({
      // eslint-disable-next-line react/no-access-state-in-setstate
      showOnlySelectedArrivalPostalOperators: this.state.showOnlySelectedArrivalPostalOperators,
    });
  };

  openSaveSelectionModalForDeparture = () => {
    this.openSaveSelectionModal({
      checkedMailProcessingCenters: createPresetSelectionsOnSave(this.props.departureCheckedMailProcessingCenters, this.props.departurePostalOperatorsNodes),
      selections: this.props.departureSelections,
      postalOperatorType: 'DEPARTURE',
    });
  };

  openSaveSelectionModalForArrival = () => {
    this.openSaveSelectionModal({
      checkedMailProcessingCenters: createPresetSelectionsOnSave(this.props.arrivalCheckedMailProcessingCenters, this.props.arrivalPostalOperatorsNodes),
      selections: this.props.arrivalSelections,
      postalOperatorType: 'ARRIVAL',
    });
  };

  render() {
    const departurePostalOperatorSelectorProps = {
      selected: this.props.departureCheckedMailProcessingCenters,
      expandDisabled: true,
      isShowOnlySelected: this.state.showOnlySelectedDeparturePostalOperators,
      postalOperatorNodes: this.state.showOnlySelectedDeparturePostalOperators ?
        this.props.selectedDeparturePostalOperatorsNodes : this.props.departurePostalOperatorsNodes,
      onSelect: this.onSelectDeparturePostalOperator,
      onSelectAll: this.onSelectAllDeparturePostalOperators,
      onDeSelectAll: this.onDeSelectAllDeparturePostalOperators,
      onShowOnlySelected: this.onToggleShowOnlySelectedDeparturePostalOperators,
      openSaveSelectionModal: this.openSaveSelectionModalForDeparture,
      saveSelectionButtonHidden: true,
    };

    return (
      <div>
        <div className="operator-selector-wrapper">
          <div className="operator-sidebar">
            <AdminPresetOperatorSidebarContainer
              operatorType={OperatorTypes.DEPARTURE}
              operators={this.props.departurePostalOperatorsNodes}
              checked={this.props.departureCheckedMailProcessingCenters}
            />
          </div>
          <div className="operators">
            <div className="operators-selection-panel">
              <div className="operator">
                <PostalOperatorSelector
                  title="OPERATOR"
                  {...departurePostalOperatorSelectorProps}
                />
              </div>

              {/* <div className="operator">
                <PostalOperatorSelector
                  title="ARRIVAL OPERATOR"
                  {...arrivalPostalOperatorSelectorProps}
                />
              </div> */}
            </div>
          </div>
          {/* <div className="operator-sidebar">
            <AdminPresetOperatorImpcSidebarContainer
              operatorType={OperatorTypes.ARRIVAL}
              operators={this.props.arrivalPostalOperatorsNodes}
                checked={this.props.arrivalCheckedMailProcessingCenters}
            />
          </div> */}
        </div>
      </div>
    );
  }
}

GlobalPresetsOperatorContainer.propTypes = {
  departurePostalOperatorsNodes: PropTypes.arrayOf(PropTypes.object),
  selectedDeparturePostalOperatorsNodes: PropTypes.arrayOf(PropTypes.object),
  departureCheckedMailProcessingCenters: PropTypes.arrayOf(PropTypes.string),
  retrieveOutboundPostalOperatorsRequestActionCreator: PropTypes.func,
  onSelectAllDepartureOperators: PropTypes.func,
  onDeSelectAllDepartureOperators: PropTypes.func,
  saveGlobalSelectionOperatorRequestActionCreator: PropTypes.func,
  departureOperatorCheckedActionCreator: PropTypes.func,
  arrivalPostalOperatorsNodes: PropTypes.arrayOf(PropTypes.object),
  arrivalCheckedMailProcessingCenters: PropTypes.arrayOf(PropTypes.string),
  selectedArrivalPostalOperatorsNodes: PropTypes.arrayOf(PropTypes.object),
  retrieveInboundPostalOperatorsRequestActionCreator: PropTypes.func,
  arrivalMailProcessingCenterCheckedActionCreator: PropTypes.func,
  onSelectAllArrivalMailProcessingCenters: PropTypes.func,
  onDeSelectAllArrivalMailProcessingCenters: PropTypes.func,
  arrivalSelections: PropTypes.arrayOf(PropTypes.shape({
    name: PropTypes.string.isRequired,
    impcCodes: PropTypes.arrayOf(PropTypes.string).isRequired,
  })),
  departureSelections: PropTypes.arrayOf(PropTypes.shape({
    name: PropTypes.string.isRequired,
    impcCodes: PropTypes.arrayOf(PropTypes.string).isRequired,
  })),
  setTabButtonStatus: PropTypes.func,
};

const mapDispatchToProps = dispatch => bindActionCreators({
  retrieveOutboundPostalOperatorsRequestActionCreator,
  departureOperatorCheckedActionCreator,
  onSelectAllDepartureOperators,
  onDeSelectAllDepartureOperators,
  retrieveInboundPostalOperatorsRequestActionCreator,
  arrivalMailProcessingCenterCheckedActionCreator,
  onSelectAllArrivalMailProcessingCenters,
  onDeSelectAllArrivalMailProcessingCenters,
  saveGlobalSelectionOperatorRequestActionCreator,
  setTabButtonStatus,
}, dispatch);

const mapStateToProps = state => ({
  selectedDeparturePostalOperatorsNodes: getSelectedDepartureOperators(state),
  departurePostalOperatorsNodes: getDepartureOperators(state),
  departureCheckedMailProcessingCenters: getDepartureCheckedOperator(state),
  arrivalCheckedMailProcessingCenters: getArrivalCheckedMailProcessingCenters(state),
  selectedArrivalPostalOperatorsNodes: getSelectedArrivalPostalOperators(state),
  arrivalPostalOperatorsNodes: getArrivalPostalOperators(state),
});

/* Needed for prop-types with cloneElement */
export const ConnectedGlobalPresetsOperatorContainer = connect(
  mapStateToProps,
  mapDispatchToProps,
)(GlobalPresetsOperatorContainer);

export default (ConnectedGlobalPresetsOperatorContainer);
